var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2949(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.146,
    height: 22.345,
    viewBox: "0 0 26.146 22.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2949",
    "data-name": "Group 2949",
    transform: "translate(-294 -632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(292.85 629.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2706",
    "data-name": "Group 2706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M20,21.85H4A2.853,2.853,0,0,1,1.15,19V5A2.853,2.853,0,0,1,4,2.15H9a.85.85,0,0,1,.707.378L11.455,5.15H20A2.853,2.853,0,0,1,22.85,8V19A2.853,2.853,0,0,1,20,21.85ZM4,3.85A1.151,1.151,0,0,0,2.85,5V19A1.151,1.151,0,0,0,4,20.15H20A1.151,1.151,0,0,0,21.15,19V8A1.151,1.151,0,0,0,20,6.85H11a.85.85,0,0,1-.707-.378L8.545,3.85Z",
    fill: "#212121"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514",
    transform: "translate(299.806 635.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(9.657 7.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M326.785,258.178a5.342,5.342,0,1,1-5.342-5.342,5.342,5.342,0,0,1,5.342,5.342",
    transform: "translate(-316.102 -252.836)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M396.246,326.111h-1.833v-1.877a.442.442,0,1,0-.885,0v1.877h-1.833a.442.442,0,0,0,0,.885h1.833v1.79a.442.442,0,1,0,.885,0V327h1.833a.442.442,0,1,0,0-.885",
    transform: "translate(-388.481 -321.176)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2949);
export default __webpack_public_path__ + "static/media/Group 2949.39b165c4d7a6cf3c493198e8d7292ec4.svg";
export { ForwardRef as ReactComponent };